import { DisplayInfo, Table } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

import { usePaymentHistoryColumns } from '../hooks/usePaymentHistoryColumns';
import { PaymentHistoryRow } from '../types';

const dictPrefix = 'financialPortal.paymentHistory.table';

interface Props {
  data: PaymentHistoryRow[];
  isLoadingResults: boolean;
  totalItems: number;
  totalPages: number;
  currentPage: number;
  itemsPerPage: number;
  hasFilters?: boolean;
  includeStudent?: boolean;
  onChangePage: (page: number) => void;
  onClickDetail: (row: PaymentHistoryRow) => void;
  onDownloadAttachment: (url: string) => void;
}

export function PaymentHistoryTable({
  data,
  isLoadingResults,
  totalItems,
  totalPages,
  currentPage,
  itemsPerPage,
  hasFilters,
  includeStudent = true,
  onChangePage,
  onClickDetail,
  onDownloadAttachment,
}: Props) {
  const { t } = useTranslation();
  const columns = usePaymentHistoryColumns({
    includeStudent,
    onClickDetail,
    onDownloadAttachment,
  });

  return (
    <Table
      isLoadingResults={isLoadingResults}
      data={data}
      columns={columns}
      pagination={{
        currentPage: currentPage + 1,
        itemsPerPage,
        totalItems,
        totalPages,
        onChangePage: (page) => onChangePage(page - 1),
      }}
      noResultsText={
        <div className="d-flex justify-content-center align-items-center py-5">
          <DisplayInfo
            iconName="information"
            textBody={t(
              `${dictPrefix}.${
                hasFilters ? 'noResultsFilter' : 'noResults'
              }.description`,
            )}
            maxWidth="650px"
          />
        </div>
      }
    />
  );
}
